import styled from '@emotion/styled'
import { Box, useDisclosure } from '@chakra-ui/react'
import { Icons } from 'stylewhere/components'

interface Props {
  title?: string
  children: any
  defaultIsClosed?: boolean
}

const Collapse = styled.div<{ in: boolean }>`
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  max-height: ${({ in: isOpen }) => (isOpen ? '1000px' : '0')};
`

export default function CollapsibleSection({ title, defaultIsClosed, children }: Props) {
  const { open, onToggle } = useDisclosure({ defaultOpen: !defaultIsClosed })

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        {title && <Title>{title}</Title>}
        <Box onClick={onToggle} cursor="pointer" style={{ padding: 20 }}>
          {open ? <Icons.ArrowUpBold /> : <Icons.ArrowDownBold />}
        </Box>
      </Box>
      <Collapse in={open}>{children}</Collapse>
    </Box>
  )
}

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
`
